package com.ijoin.analytics

import com.ijoin.BuildConfig

actual object AnalyticsTracker {
    private fun ensureInit() {
        if (!BuildConfig.ANALYTICS_ENABLED) return
        PixelTracker.init()
    }

    actual fun trackViewContent(contentId: String?, contentName: String?) {
        if (!BuildConfig.ANALYTICS_ENABLED) return
        ensureInit()
        PixelTracker.trackStandard(
            event = "ViewContent",
            params = buildMap {
                if (!contentId.isNullOrBlank()) {
                    put("content_ids", arrayOf(contentId))
                    put("content_type", "event")
                }
                if (!contentName.isNullOrBlank()) {
                    put("content_name", contentName)
                }
            }
        )
    }

    actual fun trackHomeFromEvent(eventId: String?, contentName: String?) {
        if (!BuildConfig.ANALYTICS_ENABLED) return
        ensureInit()
        PixelTracker.trackCustom(
            event = "HomeFromEvent",
            params = buildMap {
                if (!eventId.isNullOrBlank()) put("event_id", eventId)
                if (!contentName.isNullOrBlank()) put("content_name", contentName)
            }
        )
    }

    actual fun trackCompleteRegistration(source: String?) {
        if (!BuildConfig.ANALYTICS_ENABLED) return
        ensureInit()
        PixelTracker.trackStandard(
            event = "CompleteRegistration",
            params = buildMap {
                if (!source.isNullOrBlank()) put("source", source)
            }
        )
    }

    actual fun trackSchedule(eventId: String?, eventType: String?, title: String?) {
        if (!BuildConfig.ANALYTICS_ENABLED) return
        ensureInit()
        PixelTracker.trackStandard(
            event = "Schedule",
            params = buildMap {
                if (!eventId.isNullOrBlank()) put("event_id", eventId)
                if (!eventType.isNullOrBlank()) put("event_type", eventType)
                if (!title.isNullOrBlank()) put("title", title)
                put("content_type", "event")
            }
        )
    }
}
